<script lang="ts">
    import { closeModal, openModal } from 'svelte-modals';
    import { _ } from 'svelte-i18n';

    import FilterVehicles from '../Filter/FilterVehicles.svelte';
    import VehicleList from '../Vehicles/VehicleList.svelte';
    import LinkSmallBlack from '../../shared/LinkSmallBlack.svelte';
    import CheckboxLikeFilter from '../../shared/CheckboxLikeFilter.svelte';
    import Tabs from '../../shared/Tabs.svelte';
    import { features } from '../../shared/Features/features';

    export let isOpen: boolean = false;
    export let onClick: (vehicleId: number | null) => void = () => {};
    export let alreadyUsedVehicles: number[];
    export let allowUseAlreadyUsedVehicle: boolean = true;
    export let allowToRemoveAssignment: boolean = true;

    let activeOnly: boolean = false;
    let writableMode: boolean = false;
    let onlyNotUsed: boolean = false;
    let selectedViewId: string = 'vehicle';

    function onSelect(vehicleId: number | null) {
        // if (vehicleId!==null && alreadyUsedVehicles.includes(vehicleId)) {
        //     openModal(ModalConfirm, {
        //         title: $_('Potwierdzenie'),
        //         text: $_('Czy na pewno chcesz przypisać ten pojazd do reguły? Obecne przypisanie tego pojazdu zostanie usunięte.'),
        //         onClick: () => {
        //             closeModal();
        //             onClick(vehicleId);
        //         }
        //     });
        // } else {
        closeModal();
        onClick(vehicleId);
        // }
    }
</script>

{#if isOpen}
    <div role="dialog" class="modal">
        <div class="contents">
            <div
                style="display: flex; align-items: center; column-gap: 20px; justify-content: space-between; padding:10px 20px 0 20px;"
            >
                <div style="font-size: 18px; font-weight: 500; text-transform: capitalize;">
                    {$_('select_vehicle')}
                </div>
                {#if $features?.feature_vehicle_groups}
                    <div>
                        <Tabs
                            selectedId={selectedViewId}
                            items={[
                                { id: 'vehicle', label: $_('Vehicles') },
                                { id: 'vehicle_group', label: $_('vehicle_group_label') },
                            ]}
                            onChange={id => {
                                // addMode = false;
                                selectedViewId = id;
                            }}
                        />
                    </div>
                {/if}
                <!--                <div style="display: flex; flex-direction: row; align-items: center; column-gap: 10px;">-->
                <!--                    <CheckboxLikeFilter bind:checked={activeOnly} label="Tylko aktywne" />-->
                <!--                    <CheckboxLikeFilter bind:checked={onlyNotUsed} label="Tylko nieużyte" />-->
                <!--                    &lt;!&ndash;                <Switch bind:checked={activeOnly} label="Tylko aktywne" />&ndash;&gt;-->
                <!--                    &lt;!&ndash;                <Switch checked={false} label="Tylko dostępne"/>&ndash;&gt;-->
                <!--                </div>-->
            </div>
            <div
                style="display: flex; flex-direction: row; column-gap: 10px; padding:0 20px 0 20px; justify-content: space-between;"
            >
                <div>
                    <FilterVehicles />
                </div>
                <div
                    style="display: flex; flex-direction: row; align-items: center; column-gap: 10px;"
                >
                    <CheckboxLikeFilter
                        bind:checked={activeOnly}
                        label={$_('only_confirmed_by_email')}
                    />
                    <CheckboxLikeFilter
                        bind:checked={onlyNotUsed}
                        label={$_('only_not_already_used')}
                    />
                </div>
            </div>
            {#if selectedViewId === 'vehicle'}
                <div class="scrollable-list">
                    <VehicleList
                        {alreadyUsedVehicles}
                        {allowUseAlreadyUsedVehicle}
                        addMode={false}
                        letAddVehicle={false}
                        compactMode={true}
                        {onlyNotUsed}
                        {activeOnly}
                        {onSelect}
                        {writableMode}
                        is_group={false}
                    />
                </div>
            {/if}
            {#if selectedViewId === 'vehicle_group'}
                <div class="scrollable-list">
                    <VehicleList
                        {alreadyUsedVehicles}
                        {allowUseAlreadyUsedVehicle}
                        addMode={false}
                        letAddVehicle={false}
                        compactMode={true}
                        {onlyNotUsed}
                        {activeOnly}
                        {onSelect}
                        {writableMode}
                        is_group={true}
                    />
                </div>
            {/if}
            <div class="actions">
                {#if allowToRemoveAssignment}
                    <LinkSmallBlack
                        text={$_('remove_assignment')}
                        on:click={() => {
                            onSelect(null);
                        }}
                    />
                {/if}
            </div>
        </div>
    </div>
{/if}

<style>
    .modal {
        position: fixed;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1002;

        /* allow click-through to backdrop */
        pointer-events: none;
    }

    .contents {
        width: 650px;
        border-radius: 6px;
        background: white;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        pointer-events: auto;
        font-size: 14px;
        padding: 20px 20px 30px 20px;
        height: 560px;
        row-gap: 20px;
        /*background: silver;*/
    }

    .scrollable-list {
        overflow-y: auto;
        overflow-x: hidden;
        max-height: 450px;
        background-color: white;
        padding: 20px 0;
        border-radius: 3px;
        flex: 1 1 auto;
        /*overflow: hidden;*/
    }
    .actions {
        padding: 0 20px 20px 20px;
    }
</style>
